import * as _ from "lodash";
import * as React from "react";
import { default as TriggerInput, InputMode } from "./TriggerInput";
import { IQueueTriggerBaseConfig } from "processEditor/model/ITriggerData";
export const RabbitMQTrigger: React.FunctionComponent<RabbitMQTriggerProps> = (props) => {

    function isReplyDisabled(): boolean {
        const value = !_.get(props.existingParameters, "reply", false) && !_.get(props.existingParameters, "replyErrors", false);
        return value;
    }

    return (<div>
        <TriggerInput existingParameters={props.existingParameters} name="queueName" label={FRENDS.Localizations.Triggers_Queue} inputMode={InputMode.text} elementId={props.id} />
        <TriggerInput existingParameters={props.existingParameters} name="connectionString" label={FRENDS.Localizations.ConnectionString} inputMode={InputMode.text} elementId={props.id} />
        <TriggerInput
            existingParameters={props.existingParameters}
            name="maxConcurrentMessages"
            label={FRENDS.Localizations.Triggers_MaxConcurrentMessages}
            inputMode={InputMode.number}
            minValue={1}
            elementId={props.id}
            description={"The maximum number of messages to process concurrently. The amount should not be too high as it might cause performance issues."}
        />
        <TriggerInput
            existingParameters={props.existingParameters}
            name="retryMessageProcessingIfExceptionThrown"
            label="Retry message processing if exception thrown"
            defaultValue={false}
            inputMode={InputMode.boolean}
            elementId={props.id}
            description={"If set, and the first process execution fails in an exception, the process is executed a second time."}
        />
        <TriggerInput
            existingParameters={props.existingParameters}
            name="reply"
            label={FRENDS.Localizations.Triggers_Reply}
            inputMode={InputMode.boolean}
            elementId={props.id}
            description={FRENDS.Localizations.ServiceBus_Reply_Description}
        />
        <TriggerInput
            existingParameters={props.existingParameters}
            name="replyErrors"
            label={FRENDS.Localizations.Triggers_ReplyErrors}
            inputMode={InputMode.boolean}
            elementId={props.id}
            description={FRENDS.Localizations.ServiceBus_ReplyErrors_Description}
        />
        <TriggerInput
            existingParameters={props.existingParameters}
            name="replyTo"
            label={FRENDS.Localizations.Triggers_ReplyTo}
            inputMode={InputMode.text}
            disabled={isReplyDisabled()}
            elementId={props.id}
            description={FRENDS.Localizations.ServiceBus_ReplyTo_Description}
        />
    </div>);
};
export interface RabbitMQTriggerConfig extends IQueueTriggerBaseConfig {
    retryMessageProcessingIfExceptionThrown?: boolean;
    maxConcurrentMessages: number;
    connectionString?: string;
}

interface RabbitMQTriggerProps {
    id: string;
    existingParameters: RabbitMQTriggerConfig;
}
